// import React from "react";
// import Slider from "react-slick";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Link } from "react-router-dom";
// import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";

// const providers = [
//   { id: 1, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
//   { id: 2, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" },
//   { id: 3, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
//   { id: 4, name: "JILI", logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=298,fit=crop,q=95/A1a1PR3o0rH480Bj/jili_logo-YD08lRRRZWTrDjPV.png" },
//   { id: 5, name: "Royal Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/4223.png" },
//   { id: 6, name: "Evolution Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3273.png" },
//   { id: 7, name: "QTech", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3275.png" },
//   { id: 8, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" },
// ];

// function NextArrow({ onClick }) {
//   return (
//     <div className="position-absolute top-50 end-0 translate-middle-y" onClick={onClick} style={{ zIndex: 10, cursor: "pointer" }}>
//       <FaChevronRight size={24} />
//     </div>
//   );
// }

// function PrevArrow({ onClick }) {
//   return (
//     <div className="position-absolute top-50 start-0 translate-middle-y" onClick={onClick} style={{ zIndex: 10, cursor: "pointer" }}>
//       <FaChevronLeft size={24} />
//     </div>
//   );
// }

// const ProviderMarquee = () => {
//   const settings = {
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     speed: 500,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 4 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 3 },
//       },
//       {
//         breakpoint: 480,
//         settings: { slidesToShow: 2 },
//       },
//     ],
//   };

//   return (
//     <div className="position-relative bg-light py-4">
//     <div className="bg-black d-flex align-content-center justify-content-between rounded p-2 shadow-lg mb-2 fs-5"><p>Provider</p><Link to="" className="text-warning">See All <FaArrowRightLong /></Link></div>
//       <Slider {...settings}>
//         {providers.map((provider) => (
//         <div key={provider.id}>
//         <img 
//            src={provider.logo}
//            alt={provider.name}
//            className="img-fluid shadow-sm gap-1"
//            style={{ height: "1rem", objectFit: "contain", margin: "0 auto" }}
//          />
//         </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default ProviderMarquee;


import React from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";

const providers = [
  { id: 1, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
  { id: 2, name: "Royal Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/4223.png" },
  // { id: 2, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" },
  
  { id: 3, name: "JILI", logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=298,fit=crop,q=95/A1a1PR3o0rH480Bj/jili_logo-YD08lRRRZWTrDjPV.png" },
  { id: 4, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
  { id: 5, name: "Evolution Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3273.png" },
  { id: 6, name: "QTech", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3275.png" },
  // { id: 7, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" },
];

function NextArrow({ onClick }) {
  return (
    <div className="position-absolute top-50 end-0 translate-middle-y" onClick={onClick} style={{ zIndex: 10, cursor: "pointer" }}>
      <FaChevronRight size={20} className="text-dark" />
    </div>
  );
}

function PrevArrow({ onClick }) {
  return (
    <div className="position-absolute top-50 start-0 translate-middle-y" onClick={onClick} style={{ zIndex: 10, cursor: "pointer" }}>
      <FaChevronLeft size={20} className="text-dark" />
    </div>
  );
}

const ProviderMarquee = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <div className="position-relative bg-light py-4 px-3">
      <div className="d-flex justify-content-between align-items-center bg-black text-white p-3 rounded shadow-sm mb-3">
        <h5 className="m-0">Provider</h5>
        <Link to="#" className="text-warning text-decoration-none d-flex align-items-center gap-1">
          See All <FaArrowRightLong />
        </Link>
      </div>

      <Slider {...settings}>
        {providers.map((provider) => (
          <div key={provider.id} className="px-2">
            <div className="border rounded overflow-hidden bg-white shadow-sm" style={{ height: "100px", width: "100%" }}>
              <img
                src={provider.logo}
                alt={provider.name}
                className="img-fluid w-100 h-100"
                style={{
                  objectFit: "cover", // change to 'contain' if logos are distorted
                }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProviderMarquee;
